export type LibrarySection = "home" | "periodicals" | "podcasts";

type LibraryNavigationProps = {
  section: LibrarySection;
  onSelect: (section: LibrarySection) => void;
};

const LIBRARY_SECTIONS: Array<{ id: LibrarySection; label: string }> = [
  { id: "home", label: "首页" },
  { id: "periodicals", label: "期刊" },
  { id: "podcasts", label: "播客" },
];

export function librarySectionFromSearch(search: string): LibrarySection {
  const mode = new URLSearchParams(search).get("mode");
  if (mode === "periodicals" || mode === "podcasts") return mode;
  return "home";
}

export function LibraryNavigation({
  section,
  onSelect,
}: LibraryNavigationProps): React.JSX.Element {
  return (
    <nav className="topbar-sections" aria-label="主要导航">
      {LIBRARY_SECTIONS.map((item) => (
        <button
          className={section === item.id ? "active" : ""}
          aria-current={section === item.id ? "page" : undefined}
          key={item.id}
          data-analytics-feature={`nav_${item.id}`}
          onClick={() => onSelect(item.id)}
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
}
